import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-guest',
  templateUrl: './header-guest.component.html',
  styleUrls: ['./header-guest.component.scss'],
})
export class HeaderGuestComponent implements OnInit {
  constructor(public router: Router) {}

  ngOnInit(): void {}
}
